import { replacePlusSymbol } from 'pages/products/[handle]';
import defaultCategories from '@/settings/categories/default';
import { Breadcrumb } from './[handle]/NewProductPage/types';

export function scrollToTop() {
  window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
}

export const getPageUrl = (handle: any) => {
  if (handle.includes('reebelos-gift-card')) return `/${handle}`;

  if (
    ['baby', 'power-tools', 'sports-and-fitness'].includes(handle) ||
    Object.keys(defaultCategories).includes(handle)
  ) {
    switch (handle) {
      case 'baby':
        return `/category/baby`;
      case 'power-tools':
        return `/category/tools-home-improvement`;
      case 'sports-and-fitness':
        return `/category/sports-fitness`;
      default:
        return `/category/${handle}`;
    }
  }

  return `/collections/${handle}`;
};

const certifiedPreOwnedCategories = [
  'Automotive',
  'Baby Products & Toys',
  'Fashion & Accessories',
  'Fashion & Jewelry',
  'Sports & Fitness',
  'Tools & Home Improvement',
];

export const generateProductPageTitle = (
  breadcrumb: Breadcrumb,
  productName: string,
) => {
  let prefix = 'Refurbished';
  const suffix = '| Reebelo';

  if (breadcrumb.some((b) => certifiedPreOwnedCategories.includes(b.name)))
    prefix = 'Certified Pre-Owned';

  return replacePlusSymbol(`${prefix} ${productName} ${suffix}`);
};
